import { type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '~/components/ui/select'
import { ControlledFormItem } from './controlled-form-item'

type SelectOption = {
  label: string
  value: string
}

type FormSelectProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
  control: Control<TFieldValues>
  name: TName
  label?: string
  required?: boolean
  placeholder?: string
  options: SelectOption[]
  disabled?: boolean
}

export function FormSelect<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  required,
  placeholder,
  options,
  disabled,
}: FormSelectProps<TFieldValues, TName>) {
  return (
    <ControlledFormItem
      control={control}
      name={name}
      label={label}
      required={required}
      render={(field) => (
        <Select onValueChange={field.onChange} value={field.value} disabled={disabled}>
          <SelectTrigger id={String(name)}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    />
  )
}
